import { render, staticRenderFns } from "./ManagerMiniCard.vue?vue&type=template&id=258be8b1&lang=pug&"
import script from "./ManagerMiniCard.vue?vue&type=script&lang=js&"
export * from "./ManagerMiniCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports